export enum DashboardActionType {
	FETCH_PROJECT_COSTS = 'FETCH_PROJECT_COSTS',
	STORE_PROJECT_COSTS = 'STORE_PROJECT_COSTS',

	FETCH_PROJECT_OVERVIEW = 'FETCH_PROJECT_OVERVIEW',
	STORE_PROJECT_OVERVIEW = 'STORE_PROJECT_OVERVIEW',

	FETCH_STATUS_SUMMARY = 'FETCH_STATUS_SUMMARY',
	STORE_STATUS_SUMMARY = 'STORE_STATUS_SUMMARY',

	FETCH_PROMO_CODE = 'FETCH_PROMO_CODE',

	/** Prefixed to avoid colliding with ProjectActionType.FETCH/STORE_PROMO_CODE_HISTORY */
	FETCH_PROMO_CODE_HISTORY = 'DASHBOARD_FETCH_PROMO_CODE_HISTORY',
	STORE_PROMO_CODE_HISTORY = 'DASHBOARD_STORE_PROMO_CODE_HISTORY',

	CREATE_CUSTOM_PROMO_CODE = 'CREATE_CUSTOM_PROMO_CODE',

	FETCH_DASHBOARD_PROJECTS = 'FETCH_DASHBOARD_PROJECTS',
	STORE_DASHBOARD_PROJECTS = 'STORE_DASHBOARD_PROJECTS',

	FETCH_DASHBOARD_APPROVALS = 'FETCH_DASHBOARD_APPROVALS',
	STORE_DASHBOARD_APPROVALS = 'STORE_DASHBOARD_APPROVALS',

	FETCH_DASHBOARD_TICKETS = 'FETCH_DASHBOARD_TICKETS',
	STORE_DASHBOARD_TICKETS = 'STORE_DASHBOARD_TICKETS',

	FETCH_ANALYTICS_DATA = 'FETCH_ANALYTICS_DATA',
	STORE_ANALYTICS_DATA = 'STORE_ANALYTICS_DATA',

	FETCH_FINANCIAL_DATA = 'FETCH_FINANCIAL_DATA',
	STORE_FINANCIAL_DATA = 'STORE_FINANCIAL_DATA',

	FETCH_CRM_DATA = 'FETCH_CRM_DATA',
	STORE_CRM_DATA = 'STORE_CRM_DATA',

	FETCH_EXECUTIVE_DATA = 'FETCH_EXECUTIVE_DATA',
	STORE_EXECUTIVE_DATA = 'STORE_EXECUTIVE_DATA'
}
